import { normalizeRole } from "./dashboardRouting";

const USER_KEY = "user";
const USER_MAPPING_KEY = "userMapping";

const readJson = (key, fallback = null) => {
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : fallback;
    } catch {
        return fallback;
    }
};

export const getStoredUser = () => readJson(USER_KEY, null);

export const getStoredUserMapping = () => readJson(USER_MAPPING_KEY, null);

const pickUserId = (record) =>
    record?.userId ??
    record?.user?.id ??
    record?.user?.userId ??
    record?.id ??
    null;

const pickCenterId = (record) =>
    record?.assignedCenterId ||
    record?.centerId ||
    record?.center_id ||
    record?.center?.centerId ||
    record?.center?.id ||
    record?.trainingCenterId ||
    record?.employee?.centerId ||
    record?.employee?.center?.centerId ||
    "";

const pickValue = (...values) => values.find((value) => value !== undefined && value !== null && value !== "") || "";

export const getCurrentUserId = () => {
    const user = getStoredUser();
    const mapping = getStoredUserMapping();

    return pickUserId(user) || pickUserId(mapping);
};

export const getAssignedCenterId = () => {
    const user = getStoredUser();
    const mapping = getStoredUserMapping();

    return pickCenterId(user) || pickCenterId(mapping);
};

export const isCenterManagerUser = (role = null) => {
    const userRole = role || getStoredUser()?.role || "";
    const normalizedRole = normalizeRole(userRole);
    return normalizedRole === "CENTER_MANAGER" || normalizedRole === "CM";
};

export const shouldScopeToAssignedCenter = () => {
    return isCenterManagerUser() && Boolean(getAssignedCenterId());
};

export const mergeUserWithMapping = (user, mapping) => {
    const mappedUser = mapping?.user || {};
    const assignedCenterId = pickCenterId(mapping) || pickCenterId(user);
    const mergedUserId = pickUserId(user) || pickUserId(mapping);

    return {
        ...mappedUser,
        ...user,
        id: mergedUserId,
        userId: mergedUserId,
        fullName: pickValue(user?.fullName, mappedUser?.fullName, mapping?.fullName),
        email: pickValue(user?.email, mappedUser?.email, mapping?.email, user?.username),
        role: pickValue(user?.role, mappedUser?.role, mapping?.role),
        assignedCenterId,
        centerId: assignedCenterId || pickCenterId(user),
        centerName: pickValue(user?.centerName, mapping?.centerName, mapping?.center?.centerName, mapping?.center?.trainingCentreName),
        phoneNo: pickValue(mapping?.phoneNo, mappedUser?.phoneNo, user?.phoneNo),
        gender: pickValue(mapping?.gender, mappedUser?.gender, user?.gender),
        address: pickValue(mapping?.address, mappedUser?.address, user?.address),
        photo: pickValue(mapping?.photo, mappedUser?.photo, user?.photo),
        generalInfo: pickValue(mapping?.generalInfo, mappedUser?.generalInfo, user?.generalInfo),
        userMappingId: mapping?.id || null
    };
};

export const storeUserSession = (user, mapping = null) => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));

    if (mapping) {
        localStorage.setItem(USER_MAPPING_KEY, JSON.stringify(mapping));
    } else {
        localStorage.removeItem(USER_MAPPING_KEY);
    }
};

export const clearStoredUserSession = () => {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(USER_MAPPING_KEY);
};
